import type { BizIconProps } from './base';
import BizIconSvg from './base';

/** IconBlacklistShield — 黑名单盾牌：盾形轮廓，表达「封禁 / 拦截」语义 */
export default function IconBlacklistShield(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      <path d="M8 1.73 13.33 3.33v4.07c0 3.33-2.2 5.73-5.33 6.87-3.13-1.13-5.33-3.53-5.33-6.87V3.33l5.33-1.6Z" />
    </BizIconSvg>
  );
}
